<template>
  <Entity :entityData="entityData"/>
</template>

<script>
import Entity from '@/components/Entities/Entity';
import { mapState } from 'vuex';

export default {
  props: ['entityId'],
  components: { Entity },
  computed: {
    ...mapState('cmsApiCatalogs', ['diagnostic']),
    entityData() {
      return {
        type: 'diagnostic',
        entitiesString: 'diagnostics',
        entity: this.diagnostic.diagnostic,
        details: this.diagnostic.details,
        entityId: this.entityId,
        texts: {
          getMethod: 'getEntityTexts',
          saveMethod: 'saveEntityTexts',
          entitiesString: 'diagnostics',
          defaultTexts: [
            { text: '', alias: 'txt_short'},
            { text: '', alias: 'txt_long'},
            { text: '', alias: 'txt_procedure_3_clinics'},
            { text: '', alias: 'txt_table'},
            { text: '', alias: 'trust_block'},
            { text: '', alias: 'txt_price'}
          ],
        },
      };
    },
  },
}
</script>
